import {
  Droplet,
  HandHeart,
  Snowflake,
  UserRound,
  UsersRound,
  type LucideIcon,
} from "lucide-react-native";
import type { TreatmentStepConfig } from "./treatmentFlows";

type StepField = NonNullable<TreatmentStepConfig["fields"]>[number];

/**
 * Step choices that are a one-off either/or, shown as a two-way toggle with an
 * icon per side instead of a grid of tiles: who the sperm comes from, and
 * whether the sample is fresh or frozen. Keyed by field name, then option.
 *
 * `self` is the partner-perspective source: an AMAB viewer of a shared cycle
 * answers "mine or a donor's", so "partner" becomes him (see `partnerCopy`).
 */
const STEP_FIELD_TOGGLE_ICONS: Record<string, Record<string, LucideIcon>> = {
  spermSource: { self: UserRound, partner: UsersRound, donor: HandHeart },
  spermType: { fresh: Droplet, frozen: Snowflake },
};

/**
 * The icon for each option when a select field renders as a toggle, or null
 * when it keeps the option picker. A field is a toggle only when every one of
 * its options has an icon here.
 */
export function getStepFieldToggleIcons(
  field: StepField,
): Record<string, LucideIcon> | null {
  const icons = STEP_FIELD_TOGGLE_ICONS[field.name];
  const options = field.options ?? [];
  if (!icons || options.length === 0) return null;
  return options.every((option) => icons[option]) ? icons : null;
}
